export default __webpack_public_path__ + "static/media/table-maps.c3668410.svg";